/* CUSTOM_SUGSEARCH_BY_CLAUDE (ONYX 9d602af129bd, Ryan 2026-10-13) - AI Agents -> Suggestions: search every card by its words.
   ─────────────────────────────────────────────────────────────────────────────
   Ryan: "every card, including old built ones, must be findable near-instantly." The tab loads the newest 200 cards and
   its box took an exact id only. Words in the box now ask the worker (GET /agent-suggestions?q=, every word must match,
   every status, any age) and list the hits under the box; a click jumps to the card through the section's own
   find-by-id. When the worker stops short (it reads at most 600 cards a call) a "Search older cards" button carries on.
   The section is at its size cap, so it only calls run(); hitsHtml is pure and exported for tests. */
(function (root) {
  'use strict';

  function hitsHtml(q, body, esc, offset) {
    var items = (body && body.items) || [];
    var c = (body && body.counts) || {};
    var rows = items.map(function (x) {
      return '<button type="button" class="rqa-btn" data-sug-hit="' + esc(x.id) + '" style="display:block;text-align:left;width:100%;margin:4px 0;white-space:normal">'
        + '<b>' + esc(x.id) + '</b> · ' + esc(x.status) + ' · ' + esc(x.title)
        + (x.search && x.search.snippet ? '<br><span style="opacity:.75">' + esc(x.search.snippet) + '</span>' : '')
        + '</button>';
    }).join('');
    var head = items.length
      ? items.length + ' card' + (items.length === 1 ? '' : 's') + ' found for "' + q + '".'
      : 'No card holds every word of "' + q + '"' + (c.complete ? '.' : ' in the newest ' + ((offset || 0) + (c.scanned || 0)) + ' cards.');
    var more = body && body.next ? '<button type="button" class="rqa-btn" data-sug-more="' + esc(body.next.offset) + '">Search older cards</button>' : '';
    return '<div class="rqa-note">' + esc(head) + rows + more + '</div>';
  }

  async function run(q, offset, h) {
    if (q.length < 2) { h.msg('rqa-sug-msg', 'bad', 'Type a card id, or two or more letters to search every card.'); return; }
    h.msg('rqa-sug-msg', '', 'Searching...');
    var r = await h.api('/agent-suggestions?q=' + encodeURIComponent(q) + '&limit=25&history=1' + (offset ? '&offset=' + offset : ''));
    if (!r.ok) { h.msg('rqa-sug-msg', 'bad', (r.body && r.body.error) || ('Search failed (' + r.status + ').')); return; }
    ((r.body && r.body.items) || []).forEach(function (x) {
      if (!h.held.some(function (s) { return s.id === x.id; })) h.held.push(x);
    });
    h.box.innerHTML = hitsHtml(q, r.body, h.esc, offset);
  }

  var api = { run: run, hitsHtml: hitsHtml };
  root.RQASugSearch = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
